export default __webpack_public_path__ + "static/media/abilis-logo-white.d0e4cc4f.svg";